"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reselect = require("reselect");

var collectionsStateSelector = function collectionsStateSelector(state) {
  return state.collections;
};

var loadCollectionsSelector = (0, _reselect.createSelector)(collectionsStateSelector, function (collections) {
  return collections.loadCollections;
});
var loadCollectionsSuccessSelector = (0, _reselect.createSelector)(loadCollectionsSelector, function (loadCollections) {
  return loadCollections.success;
});
var loadCollectionsDataSelector = (0, _reselect.createSelector)(loadCollectionsSelector, function (loadCollections) {
  return loadCollections.data;
});
var highLightedCollectionSelector = (0, _reselect.createSelector)(loadCollectionsDataSelector, function (collectionsData) {
  return collectionsData === null || collectionsData === void 0 ? void 0 : collectionsData.find(function (collection) {
    return collection === null || collection === void 0 ? void 0 : collection.isHighlighted;
  });
});
var loadCollectionsMetaSelector = (0, _reselect.createSelector)(loadCollectionsSelector, function (loadCollections) {
  return loadCollections.meta;
});
var loadCollectionsIsLoadingSelector = (0, _reselect.createSelector)(loadCollectionsSelector, function (loadCollections) {
  return loadCollections.isLoading;
});
var loadCollectionsErrorSelector = (0, _reselect.createSelector)(loadCollectionsSelector, function (loadCollections) {
  return loadCollections.error;
});
var loadCollectionSelector = (0, _reselect.createSelector)(collectionsStateSelector, function (collections) {
  return collections.loadCollection;
});
var loadCollectionDataSelector = (0, _reselect.createSelector)(loadCollectionSelector, function (loadCollection) {
  return loadCollection.data;
});
var loadCollectionIsLoadingSelector = (0, _reselect.createSelector)(loadCollectionSelector, function (loadCollection) {
  return loadCollection.isLoading;
});
var loadCollectionErrorSelector = (0, _reselect.createSelector)(loadCollectionSelector, function (loadCollection) {
  return loadCollection.error;
});
var createCollectionSelector = (0, _reselect.createSelector)(collectionsStateSelector, function (collections) {
  return collections.createCollection;
});
var createdCollectionSuccessSelector = (0, _reselect.createSelector)(createCollectionSelector, function (createCollection) {
  return createCollection.success;
});
var createCollectionIsLoadingSelector = (0, _reselect.createSelector)(createCollectionSelector, function (createCollection) {
  return createCollection.isLoading;
});
var createCollectionErrorSelector = (0, _reselect.createSelector)(createCollectionSelector, function (createCollection) {
  return createCollection.error;
});
var editCollectionSelector = (0, _reselect.createSelector)(collectionsStateSelector, function (collections) {
  return collections.editCollection;
});
var editedCollectionSuccessSelector = (0, _reselect.createSelector)(editCollectionSelector, function (editCollection) {
  return editCollection.success;
});
var editCollectionIsLoadingSelector = (0, _reselect.createSelector)(editCollectionSelector, function (editCollection) {
  return editCollection.isLoading;
});
var editCollectionErrorSelector = (0, _reselect.createSelector)(editCollectionSelector, function (editCollection) {
  return editCollection.error;
});
var deleteCollectionSelector = (0, _reselect.createSelector)(collectionsStateSelector, function (collections) {
  return collections.deleteCollection;
});
var deleteCollectionSuccessSelector = (0, _reselect.createSelector)(deleteCollectionSelector, function (deleteCollection) {
  return deleteCollection.success;
});
var deleteCollectionIsLoadingSelector = (0, _reselect.createSelector)(deleteCollectionSelector, function (deleteCollection) {
  return deleteCollection.isLoading;
});
var deleteCollectionErrorSelector = (0, _reselect.createSelector)(deleteCollectionSelector, function (deleteCollection) {
  return deleteCollection.error;
});
var _default = {
  loadCollectionsSuccessSelector: loadCollectionsSuccessSelector,
  loadCollectionsDataSelector: loadCollectionsDataSelector,
  loadCollectionsMetaSelector: loadCollectionsMetaSelector,
  loadCollectionsIsLoadingSelector: loadCollectionsIsLoadingSelector,
  loadCollectionsErrorSelector: loadCollectionsErrorSelector,
  loadCollectionDataSelector: loadCollectionDataSelector,
  loadCollectionIsLoadingSelector: loadCollectionIsLoadingSelector,
  loadCollectionErrorSelector: loadCollectionErrorSelector,
  createdCollectionSuccessSelector: createdCollectionSuccessSelector,
  createCollectionIsLoadingSelector: createCollectionIsLoadingSelector,
  createCollectionErrorSelector: createCollectionErrorSelector,
  editedCollectionSuccessSelector: editedCollectionSuccessSelector,
  editCollectionIsLoadingSelector: editCollectionIsLoadingSelector,
  editCollectionErrorSelector: editCollectionErrorSelector,
  deleteCollectionSuccessSelector: deleteCollectionSuccessSelector,
  deleteCollectionIsLoadingSelector: deleteCollectionIsLoadingSelector,
  deleteCollectionErrorSelector: deleteCollectionErrorSelector,
  highLightedCollectionSelector: highLightedCollectionSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map